import { ValidationClientGroup } from './enum/validation-client-group.enum';
import { ValidationInterface } from './validation.interface';

export class ValidationClient {
    private readonly _group: ValidationClientGroup = undefined;

    private readonly _validation: ValidationInterface = undefined;

    constructor(group: ValidationClientGroup, validation: ValidationInterface) {
        this._group = group;
        this._validation = validation;
    }

    get group(): ValidationClientGroup {
        return this._group;
    }

    get validation(): ValidationInterface {
        return this._validation;
    }
}
